import { render } from "./CompanyFormContainer.vue?vue&type=template&id=44b6f325"
import script from "./CompanyFormContainer.vue?vue&type=script&lang=js"
export * from "./CompanyFormContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__